import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const ShipmentsPagePage = lazy(() => import("./Page"));
const ShipmentEditPage = lazy(() => import("./ShipmentEditPage"));

export const ShipmentsPrototypeRoutes = () => (
  <Switch>
    <Route
      path="/kvz/shipments-page/:shipmentId/edit"
      component={ShipmentEditPage}
    />
    <Route exact path="/kvz/shipments-page" component={ShipmentsPagePage} />
  </Switch>
);
